import { render, staticRenderFns } from "./healthtrackingNext.vue?vue&type=template&id=a442429c&"
import script from "./healthtrackingNext.vue?vue&type=script&lang=js&"
export * from "./healthtrackingNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports